import MarketingReducer from "./marketing";
import ProgramTypeReducer from "./program-type";
import ValueRankingReducer from "./value-ranking";

export default {
    marketing:MarketingReducer,
    programType:ProgramTypeReducer,
    valueRanking:ValueRankingReducer
}